import { createContext } from "react";

export const UserRestrictionsContext = createContext();

function UserRestrictionProvider({ children }) {



  return (
    <UserRestrictionsContext.Provider value={{}}>
      {children}


    </UserRestrictionsContext.Provider>
  );
}

export default UserRestrictionProvider;
